import qs from "qs";
import { ApiClientBase } from "api/ApiClientBase";

class MunicipalitySummaryApiClient extends ApiClientBase {
    buildMunicipalitySummary(municipalityId, format) {
        return this.post(
            `api/v1/municipality/summary/${municipalityId}/build?${qs.stringify({ format })}`,
        ).then((x) => x.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new MunicipalitySummaryApiClient();
